import React from 'react';

export const Callback: React.FC = () => {
  return (
    <div>
      <h1>Callback</h1>
    </div>
  );
};
